<template>
    <DForm
        @submit.prevent="submitForm"
    >
        <div class="s3-settings-form">
            <DCard
                :title="__('settings.s3_settings.title')"
                class="mb-4"
                padding
            >
                <DFormRow
                    :label="__('settings.s3_settings.form.url')"
                    is-required
                    :error="errorsData.api_url"
                    :hint="__('settings.s3_settings.form.url_hint')"
                >
                    <DInput
                        id="api_url"
                        v-model="form.api_url"
                        :placeholder="__('settings.s3_settings.form.url')"
                        :is-valid="isFormFieldValid('api_url')"
                        maxlength="128"
                        @update:value="valueUpdated"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('settings.s3_settings.form.access_key')"
                    is-required
                    :error="errorsData.api_access_key"
                    :hint="__('settings.s3_settings.form.access_key_hint')"
                >
                    <DInput
                        id="api_access_key"
                        v-model="form.api_access_key"
                        :placeholder="__('settings.s3_settings.form.access_key')"
                        :is-valid="isFormFieldValid('api_access_key')"
                        maxlength="128"
                        @update:value="valueUpdated"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('settings.s3_settings.form.secret_key')"
                    is-required
                    :error="errorsData.api_secret_key"
                    :hint="__('settings.s3_settings.form.secret_key_hint')"
                >
                    <DInput
                        id="api_secret_key"
                        v-model="form.api_secret_key"
                        type="password"
                        :placeholder="__('settings.s3_settings.form.secret_key')"
                        :is-valid="isFormFieldValid('api_secret_key')"
                        maxlength="255"
                        @update:value="valueUpdated"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('settings.s3_settings.form.bucket_name')"
                    is-required
                    :error="errorsData.bucket_name"
                    :hint="__('settings.s3_settings.form.bucket_name_hint')"
                >
                    <DInput
                        id="bucket_name"
                        v-model="form.bucket_name"
                        :placeholder="__('settings.s3_settings.form.bucket_name')"
                        :is-valid="isFormFieldValid('bucket_name')"
                        maxlength="128"
                        @update:value="valueUpdated"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('settings.s3_settings.form.plesk_file_name')"
                    is-required
                    :error="errorsData.plesk_file_name"
                    :hint="__('settings.s3_settings.form.plesk_file_name_hint')"
                >
                    <DInput
                        id="plesk_file_name"
                        v-model="form.plesk_file_name"
                        :placeholder="__('settings.s3_settings.form.plesk_file_name')"
                        :is-valid="isFormFieldValid('plesk_file_name')"
                        maxlength="128"
                        @update:value="valueUpdated"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('settings.s3_settings.form.direct_admin_file_name')"
                    is-required
                    :error="errorsData.direct_admin_file_name"
                    :hint="__('settings.s3_settings.form.direct_admin_file_name_hint')"
                >
                    <DInput
                        id="direct_admin_file_name"
                        v-model="form.direct_admin_file_name"
                        :placeholder="__('settings.s3_settings.form.direct_admin_file_name')"
                        :is-valid="isFormFieldValid('direct_admin_file_name')"
                        maxlength="128"
                        @update:value="valueUpdated"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('settings.s3_settings.form.cpanel_file_name')"
                    is-required
                    :error="errorsData.cpanel_file_name"
                    :hint="__('settings.s3_settings.form.cpanel_file_name_hint')"
                >
                    <DInput
                        id="direct_admin_file_name"
                        v-model="form.cpanel_file_name"
                        :placeholder="__('settings.s3_settings.form.cpanel_file_name')"
                        :is-valid="isFormFieldValid('cpanel_file_name')"
                        maxlength="128"
                        @update:value="valueUpdated"
                    />
                </DFormRow>
                <DRow>
                    <DCol sm="4" />
                    <DCol sm="4">
                        <div
                            v-show="connectionStatus === 'successful'"
                            class="green-text"
                        >
                            {{ __('settings.connections.connection_successful') }}
                        </div>
                        <div
                            v-show="connectionStatus === 'unsuccessful'"
                            class="red-text"
                        >
                            {{ __('settings.connections.connection_unsuccessful') }}
                        </div>
                    </DCol>
                    <DCol
                        sm="4"
                        class="check-database-connection-btn"
                    >
                        <DButton
                            icon="lan-connect"
                            :label="__('settings.connections.check_connection')"
                            :disabled="isInLoadingState"
                            @click="checkConnection"
                        />
                    </DCol>
                </DRow>
            </DCard>
            <DCard
                :title="__('settings.s3_settings.cron_job_files_title')"
                class="mb-4"
                padding
            >
                <DFormRow
                    :label="__('settings.s3_settings.form.cronjob_file_one')"
                    :error="errorsData.cronjob_file_one"
                    :hint="__('settings.s3_settings.form.cronjob_file_one_hint')"
                >
                    <DInput
                        id="cronjob_file_one"
                        v-model="form.cronjob_file_one"
                        :placeholder="__('settings.s3_settings.form.cronjob_file_one')"
                        :is-valid="isFormFieldValid('cronjob_file_one')"
                        maxlength="128"
                        @update:value="valueUpdated"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('settings.s3_settings.form.cronjob_file_two')"
                    :error="errorsData.cronjob_file_two"
                    :hint="__('settings.s3_settings.form.cronjob_file_two_hint')"
                >
                    <DInput
                        id="cronjob_file_two"
                        v-model="form.cronjob_file_two"
                        :placeholder="__('settings.s3_settings.form.cronjob_file_two')"
                        :is-valid="isFormFieldValid('cronjob_file_two')"
                        maxlength="128"
                        @update:value="valueUpdated"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('settings.s3_settings.form.cronjob_file_three')"
                    :error="errorsData.cronjob_file_three"
                    :hint="__('settings.s3_settings.form.cronjob_file_three_hint')"
                >
                    <DInput
                        id="cronjob_file_three"
                        v-model="form.cronjob_file_three"
                        :placeholder="__('settings.s3_settings.form.cronjob_file_three')"
                        :is-valid="isFormFieldValid('cronjob_file_three')"
                        maxlength="128"
                        @update:value="valueUpdated"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('settings.s3_settings.form.cronjob_file_four')"
                    :error="errorsData.cronjob_file_four"
                    :hint="__('settings.s3_settings.form.cronjob_file_four_hint')"
                >
                    <DInput
                        id="cronjob_file_four"
                        v-model="form.cronjob_file_four"
                        :placeholder="__('settings.s3_settings.form.cronjob_file_four')"
                        :is-valid="isFormFieldValid('cronjob_file_four')"
                        maxlength="128"
                        @update:value="valueUpdated"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('settings.s3_settings.form.cronjob_file_five')"
                    :error="errorsData.cronjob_file_five"
                    :hint="__('settings.s3_settings.form.cronjob_file_five_hint')"
                >
                    <DInput
                        id="cronjob_file_five"
                        v-model="form.cronjob_file_five"
                        :placeholder="__('settings.s3_settings.form.cronjob_file_five')"
                        :is-valid="isFormFieldValid('cronjob_file_five')"
                        maxlength="128"
                        @update:value="valueUpdated"
                    />
                </DFormRow>
            </DCard>
        </div>
        <DFormControls
            :dirty="form.isDirty"
            :disabled="connectionStatus !== 'successful'"
            @submit="submitForm"
        />
        <DConnectionErrorModal
            :show-modal="connectionException !== null"
            :exception="connectionException"
            @close-modal="closeErrorCheckModal"
        />
    </DForm>
</template>

<script setup>
import { useForm } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import { ref } from 'vue'

import DConnectionErrorModal from '~@/Components/Common/DConnectionErrorModal'

const props = defineProps({
    s3Settings: {
        type: Array,
        default: () => { return [] }
    },
    errors: {
        type: Object,
        default: () => ({})
    }
})

const connectionStatus = ref(null)
const errorsData = ref(props.errors)
const connectionException = ref(null)

const emit = defineEmits(['form-submitted'])

const form = useForm({
    api_url: props.s3Settings?.api_url ?? null,
    api_access_key: props.s3Settings?.api_access_key ?? null,
    api_secret_key: props.s3Settings?.api_secret_key ?? null,
    bucket_name: props.s3Settings?.bucket_name ?? null,
    plesk_file_name: props.s3Settings?.plesk_file_name ?? null,
    direct_admin_file_name: props.s3Settings?.direct_admin_file_name ?? null,
    cpanel_file_name: props.s3Settings?.cpanel_file_name ?? null,
    cronjob_file_one: props.s3Settings?.cronjob_file_one ?? null,
    cronjob_file_two: props.s3Settings?.cronjob_file_two ?? null,
    cronjob_file_three: props.s3Settings?.cronjob_file_three ?? null,
    cronjob_file_four: props.s3Settings?.cronjob_file_four ?? null,
    cronjob_file_five: props.s3Settings?.cronjob_file_five ?? null,
})

const checkConnection = function () {
    errorsData.value = {}
    connectionException.value = null
    window.axios.post(route('settings.s3-settings.check-connection'), form)
        .then(function () {
            connectionStatus.value = 'successful'
        })
        .catch(function (error) {
            connectionStatus.value = 'unsuccessful'

            if (error.response.data.errors !== undefined) {
                errorsData.value = error.response.data.errors

                for (const key in errorsData.value) {
                    if (typeof errorsData.value[key] === 'object') {
                        errorsData.value[key] = errorsData.value[key][0]
                    }
                }
            }
            if (error?.response.data.exception !== undefined) {
                connectionException.value = error.response.data.exception
            }
        })
}

const submitForm = () => {
    emit('form-submitted', form)
}

const valueUpdated = () => {
    connectionStatus.value = null
}
const closeErrorCheckModal = () => {
    connectionException.value = null
}
</script>

<style scoped lang="scss">

.check-database-connection-btn {
    text-align: right;
    padding-bottom: 25px;
}

.green-text {
    color: green;
}
.red-text {
    color: red;
}

</style>
